import styled from '@emotion/styled';
import { spacing } from 'component-library';

export const LoaderWrapper = styled.div`
  text-align: center;
  margin-top: ${spacing.huge};
`;
